/**
 * 0-9a-zA-Z
 * @param len
 * @returns
 */
export const randomChar = (extraStr = '') => {
    const num = (Math.random() * (62 + extraStr.length)) | 0;
    if (num < 10) {
        return '' + num;
    }
    else if (num < 36) {
        return String.fromCharCode(65 + num - 10);
    }
    else if (num < 62) {
        return String.fromCharCode(97 + num - 36);
    }
    else {
        return extraStr[num - 62];
    }
};
export default (len = 1, extraStr = '') => {
    let s = '';
    while (s.length < len) {
        s += randomChar(extraStr);
    }
    return s;
};
